/* eslint-disable */

export const DELETE_ORDER = {
    FETCH_DELETE_ORDER_REQUEST: 'FETCH_DELETE_ORDER_REQUEST',
    FETCH_DELETE_ORDER_SUCCESS: 'FETCH_DELETE_ORDER_SUCCESS',
    FETCH_DELETE_ORDER_FAILURE: 'FETCH_DELETE_ORDER_FAILURE',
};
